export default {
	signUp: 'Sign up',
	password: 'We will sent you password to your email',
	youHaveRegistered: 'You have successfully registered',
	checkEmail: email => `Please, check your email ${email}`,
	passportPhoto: 'Passport photo (last page)',
	selfieWithPassport: 'Your selfie with last page of the passport',
	legalDocumentPhoto: 'Photo of legal entry registration',
	remove: 'Remove',
	addressDocumentPhoto: 'Address confirmation photo'
};
